export default "__VITE_ASSET__CU3Nx$7U__"